export const getNavItems = (t) => [
  {
    id: 1,
    name: t("nav.home"),
    link: "/",
  },
  {
    id: 2,
    name: t("nav.services"),
    link: "/services",
  },
  {
    id: 3,
    name: t("nav.enclave"),
    link: "/quivio-enclave",
  },
  {
    id: 4,
    name: t("nav.blog"),
    link: "/blog",
  },
  // {
  //   id: 5,
  //   name: t("nav.works"),
  //   link: "/works",
  // },
  {
    id: 6,
    name: t("nav.team"),
    link: "/team",
  },
  {
    id: 7,
    name: t("nav.contact"),
    link: "/contact",
  },
];
